module.exports = __webpack_public_path__ + "img/13.e5fdf237.png";